import {Component, inject, Input, OnChanges} from '@angular/core';
import {AConst} from '../../core/a-const.enum';
import {CommonsService} from '../../core/commons.service';
import {FieldStateService} from '../../core/field-state.service';
import {SectionsContainer} from '../../core/definitions/sections-container';
import {MetaField} from '../../core/definitions/meta-field';
import {Reference} from '../../core/definitions/reference';
import {SearchParameters} from '../../core/definitions/search-parameters';
import {SolrFilterService} from '../../core/solr-filter.service';
import {SearchService} from "../../core/search.service";
import {SearchReferenceService} from "../../core/search-reference.service";
import {Inline} from "../../core/definitions/inline";

@Component({
    selector: 'app-edit-field-compare',
    templateUrl: './edit-field-compare.component.html',
    styleUrls: ['./edit-field-compare.component.scss'],
    standalone: false
})
export class EditFieldCompareComponent implements OnChanges {
  // Injections
  private readonly commons: CommonsService = inject(CommonsService);
  private readonly fieldStateSvc: FieldStateService = inject(FieldStateService);
  private readonly searchReferenceService: SearchReferenceService = inject(SearchReferenceService);
  private readonly searchService: SearchService = inject(SearchService);
  private readonly solrFilter: SolrFilterService = inject(SolrFilterService);

  @Input() displayRequiredIndication: boolean;
  @Input() sectionsContainer: SectionsContainer;
  @Input() field: MetaField;
  @Input() index: number;
  @Input() parentIndex: number;
  compareFieldId: string;
  compareObject: any;
  myField: MetaField;

  ngOnChanges() {
    const reference = this.searchReferenceService.getSearchReferenceFromField(this.field);
    this.setCompareProps(reference);
    this.setCompareField().then();
  }

  setCompareProps(reference: Reference) {
    const showCondFieldName = reference.compare_value_field;
    this.compareObject = this.fieldStateSvc.getSubObject(this.sectionsContainer.rootObject, this.field, this.index, this.parentIndex);
    let compareFieldId = this.compareObject[showCondFieldName];
    const parentName = this.field[AConst.PARENT_NAME];
    if (compareFieldId === undefined && parentName) {
      this.compareObject = this.compareObject[parentName];
      compareFieldId = this.compareObject[showCondFieldName];
    }
    this.compareFieldId = compareFieldId;
  }

  async setCompareField() {
    const params = {} as SearchParameters;
    this.solrFilter.addFq(params, 'object_type', 'MetaField');
    this.solrFilter.addFq(params, 'artifact_id', this.compareFieldId);

    const res = await this.searchService.search(params);
    let fiSearch: any;
    let fiCreate: MetaField;
    let refType: string;
    let parentMeta: MetaField;
    let reference: Reference;
    let inline: Inline;
    const fi = this.field;
    const existingVal = this.compareObject[fi.name];
    if (res.artifacts) {
      const covert = <unknown>res.artifacts[0];
      fiSearch = <MetaField>covert;
      if (fiSearch.reference) {
        const fakeReference = this.parsePythonJson(fiSearch.reference);
        reference = this.searchReferenceService.getSearchReferenceFromReferenceId(fakeReference.reference_id);
        refType = reference.object_type;
        if (existingVal && existingVal.indexOf(refType) !== 0) {
          this.compareObject[fi.name] = null;
        }
      }
      if (fiSearch.inline) {
        inline = this.parsePythonJson(fiSearch.inline);
      }
      parentMeta = this.compareObject.$$meta[fi.name];
      parentMeta.reference = reference;
      parentMeta.input_type = fiSearch.input_type;
      fiCreate = this.commons.copy(fi);
      fiCreate.field_type = fiSearch.field_type;
      fiCreate.input_type = fiSearch.input_type;
      fiCreate.reference = reference;
      fiCreate.inline = inline;
      this.myField = fiCreate;
    }
  }



  parsePythonJson(inStr: string) {
    let str = inStr.replace(/'/g, '"');
    str = str.replace(/: True/g, ': true');
    str = str.replace(/: False/g, ': false');
    str = str.replace(/: None/g, ': null');
    return JSON.parse(str);
  }

}
